import { styled } from '@mui/material/styles';
import { Avatar } from '@mui/material';

export const StyledUnassignedAvatar = styled(Avatar)(({ theme }) => ({
  '&&&': {
    backgroundColor: theme.palette.grey.bt_alt_grey_light,
  },
}));
